<template>
    <div>
        <step-order></step-order>
    </div>
</template>

<script>
import MenuOrder from './menuOrder.vue';
import StepOrder from './events/order/form.vue';
import CalendarOfEvents from './calendar-of-events.vue';

export default {
  name: 'partners-cabinet',
  components: {
    CalendarOfEvents, StepOrder, MenuOrder,
  },
};
</script>

<style scoped>

</style>
